import {defineStore} from 'pinia';
import {reactive, ref} from 'vue';
import type {Question} from '@/types/question-types';

type Q = Question
const getAnsweredNumber = (arr:number[]):number =>{
    let res = 0;
    arr.forEach(i=>{
        if (i != -1) {
            res++;
        }
    });
    return res;
};

const getFlagNumber = (arr:number[]):number => {
    let res = 0;
    for (const i of arr) {
        if (i == -1) {
            return res;
        }
        res++;
    }
    return res;
};

export const questionStore = defineStore('question-store', () => {
    const questionList = reactive<Q[]>([]);
    const answerList = reactive<number[]>([]);
    const answered = ref<number>(0);
    const flag = ref<number>(0);
    const isAnswered = ref(
        localStorage.getItem('isAnswered') === 'true'
            ? true
            : false
    ); // 用户是否回答过整套题
    const resMessage = ref(
        localStorage.getItem('resMessage') === ''
            ? ''
            : localStorage.getItem('resMessage')
    ); // 如果回答整套题的显示文字


    const initQuestionList = (arr:Q[]):void =>{
        questionList.length = 0;
        arr.forEach(i=>{
            questionList.push(i);
        });
    };
    const initAnswerList = (arr:number[]):void =>{   
        answerList.length = 0;     
        arr.forEach(i=>{
            answerList.push(i);
        });
        answered.value = getAnsweredNumber(answerList);
        flag.value = getFlagNumber(answerList);
    };
    return {
        questionList,
        answerList,
        flag,
        answered,
        isAnswered,
        resMessage,
        initQuestionList,
        initAnswerList,
    };
});

export const isApply = ref<boolean>(localStorage.getItem('isApply') === 'true' ? true : false);
export const restTime = ref<boolean>(localStorage.getItem('restTime') === 'true' ? true : false);
